const getDateFromInput = (value) => {
  if (!value) {
    return new Date();
  }

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return new Date();
  }
  return date;
};

export const getTimeOfDayLabel = (value) => {
  const date = getDateFromInput(value);
  const hour = date.getHours();

  if (hour >= 5 && hour < 12) {
    return "Morning";
  }
  if (hour >= 12 && hour < 17) {
    return "Afternoon";
  }
  if (hour >= 17 && hour < 21) {
    return "Evening";
  }
  return "Night";
};

export const getDefaultRunName = (value) => {
  const label = getTimeOfDayLabel(value);
  return `${label} Run`;
};

export default getDefaultRunName;
